export default "__VITE_PUBLIC_ASSET__a231e349__"